<template>
<div
    class="login-box"
    style="min-height: 873px;"
>
    <div class="login-logo">
        <img class="img-thumbnail" src="../assets/dist/img/UDR_LOGO.png" />
        <br>
        <a href="#" ><b>Unlimited Recharge (UDR)!</b></a>
        
    </div>
    <!-- /.login-logo -->
    <div class="login-box-body">
        <h4 class="login-box-msg">{{  $t('GET_START') }}</h4>

        <form v-on:submit.prevent="login">

            <div class="form-group has-feedback">
                <input
                    type="email"
                    class="form-control"
                    placeholder="Email"
                    v-model="email"
                    name="email"
                >
                    <span class="glyphicon glyphicon-envelope form-control-feedback"></span>
            </div>

            <div class="form-group has-feedback">
                <input
                    type="password"
                    class="form-control"
                    placeholder="Password"
                    v-model="password"
                    name="password"
                >
                    <span class="glyphicon glyphicon-lock form-control-feedback"></span>
            </div>

            <div class="form-group has-error">
                <label
                    class="control-label"
                    for="inputError"
                >
                    {{ error_message }}
                    </label>
            </div>

            <div class="row">
            
                <!-- /.col -->
                <div class="col-xs-4">
                    <button
                        type="submit"
                        class="btn btn-primary btn-block btn-flat"
                    >{{  $t('LOGIN') }}</button>
                </div>
                <!-- /.col -->
            </div>
        </form>

        <!-- /.social-auth-links -->
        <router-link to="/forgotPassword">{{ $t('I_FORGOT_PASS') }}</router-link>

        <br>
    </div>
    <!-- /.login-box-body -->

    </div>
</template>

<script>
$(function() {
  $("input").iCheck({
    checkboxClass: "icheckbox_square-blue",
    radioClass: "iradio_square-blue",
    increaseArea: "20%" /* optional */
  });
});

export default {
  name: "login",

  data() {
    return {
      email: "",
      password: "",
      error_message: ""
    };
  },
  methods: {
    login() {
      let self = this;
      this.$store.state.services.userService
        .login(self.email, self.password)
        .then(async response => {
          self.$store
            .dispatch("logIn", response.data)
            .then(data => {
                
              self.$router.push("/home");
             
            })
            .catch(error => {
              alert(error);
            });
        })
        .catch(reason => {
          //console.log(reason);
          self.error_message = "Usuario o Contraseña no válidos!";
          // = 'Usuario o Contraseña no validos!'
        });
    }
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/login.vue